//reformatage des prix, €5.600,00 -> €5 600,00
document.addEventListener("DOMContentLoaded", function () {
document.querySelectorAll(".price-item").forEach(priceElement => {
    let priceText = priceElement.textContent.trim();

    // Vérifier si le format contient un point comme séparateur de milliers
    if (priceText.includes(".")) {
      // Supprimer le point séparateur incorrect
      let cleanedPrice = priceText.replace(".", "");

      // Ajouter un espace pour séparer les milliers
      let formattedPrice = cleanedPrice.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");

      // Mettre à jour le texte affiché
      priceElement.textContent = formattedPrice;
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".price").forEach(priceElement => {
    let priceText = priceElement.textContent.trim();

    
    if (priceText.includes(".")) {
      
      let cleanedPrice = priceText.replace(".", "");

     
      let formattedPrice = cleanedPrice.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");

     
      priceElement.textContent = formattedPrice;
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".totals__subtotal-value").forEach(priceElement => {
    let priceText = priceElement.textContent.trim();

   
    if (priceText.includes(".")) {
      
      let cleanedPrice = priceText.replace(".", "");

     
      let formattedPrice = cleanedPrice.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");

     
      priceElement.textContent = formattedPrice;
    }
  });
});

